import axios from "./axiosConfig";
const inscriptionUrl = process.env.REACT_APP_INSCRIPTION_URL;

export const postPayment = async (body) => {
  try {
    const resp = await axios.post(`/payments/mp/preference`, body);
    return resp.data;
  } catch (e) {
    throw e;
  }
};

export const postPaypalPayment = async (body) => {
  try {
    const resp = await axios.post(`/payments/paypal/preference`, body);
    return resp.data;
  } catch (e) {
    throw e;
  }
};

export const postUser = async (body) => {
  try {
    const resp = await axios.post(`/payments`, body);
    return resp.data;
  } catch (e) {
    throw e;
  }
};

export const postUserToBC = async (body) => {
  try {
    const resp = await axios.post(`${inscriptionUrl}/inscription`, body);
    return resp.data;
  } catch (e) {
    throw e;
  }
};
